import React, { Component } from 'react';
import { images } from '../../settings';

import './Footer.scss';

class Footer extends Component {
  click = () => {
    this.props.clicked();
  };

  showInScroll() {
    window.addEventListener('scroll', () => {
      let windowY = window.scrollY;
      windowY > 300
        ? document.querySelector('.btn_topo').classList.add('active')
        : document.querySelector('.btn_topo').classList.remove('active');
    });
  }

  componentDidMount() {
    this.showInScroll();
  }

  render() {
    return (
      <footer className="site-footer">
        <div className="footer-1"></div>
        <div className="footer-2"></div>
        <div className="footer-3"></div>

        <div className="btn_topo" onClick={() => this.click()}>
          <img src={images.btn_topo} />
        </div>
      </footer>
    );
  }
}

export { Footer };
